<div class="app-container">
  <div *ngIf="!fromClientPortal">
    <public-header
      *nativeAppHidden
      [providerPracticeState]="providerShareableProfile?.practice_state?.abbrev"
    >
    </public-header>
  </div>
  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="isValid; else notFound">
      <main class="main-content" (scroll)="areActionsScrolledIntoView()">
      <landing-page-banner></landing-page-banner>
      <div class="container-wrapper">
        <div class="content-wrapper">
          <div class="left-col">
            <landing-page-header
              *ngIf="providerShareableProfile"
              [providerShareableProfile]="providerShareableProfile"
              [paramsShareCode]="paramsShareCode"
              [paramsName]="paramsName"
              [queryParamMap]="queryParamMap"
              [requestSessionQueryParams]="requestSessionQueryParams"
              [topSpecialties]="topSpecialties"
              [hideNotAcceptingNotice]="hasMatchedWithProvider()"
              (requestASessionClicked)="onRequestSessionButtonClicked()"
            >
            </landing-page-header>

          </div>

          <div class="right-col">
            <div #actions class="actions">
              <div *ngIf="!fromClientPortal">
                <iris-card *ngIf="isCalendarLoading" class="actions-loader-container" [elevation]="1">
                  <div class="actions-loader loading-spinner"></div>
                </iris-card>
                <iris-card
                  *ngIf="(showProviderCalendar$ | async) && !isCalendarLoading && !(isScheduled)"
                  id="public-provider-calendar"
                  class="provider-calendar-card"
                  data-test="calendar-form"
                  [elevation]="1"
                >
                  <public-provider-calendar
                    [appointmentSlots]="appointmentSlots$ | async"
                    (appointmentSlotsProcessed)="onCalendarInit($event)"
                    (requestASessionClicked)="onRequestSessionButtonClicked($event)"
                    [providerId]="providerShareableProfile?.id"
                    [providerPrimaryAddress]="providerPrimaryAddress"
                    [providerSessionTypesOffered]="providerShareableProfile?.session_types_offered"
                    [providerTimeZone]="providerShareableProfile?.time_zone"
                  >
                  </public-provider-calendar>
                </iris-card>

                <connect-card
                  id="connect-card"
                  *ngIf="!(showProviderCalendar$ | async) && !isCalendarLoading"
                  [accepting]="providerShareableProfile?.accepting_clients"
                  [firstName]="providerShareableProfile?.display_first_name"
                  [paramsShareCode]="paramsShareCode"
                  [paramsName]="paramsName" [requestSessionQueryParams]="requestSessionQueryParams"
                  [soonestAvailableDate]="soonestAvailableDate$ | async"
                  (requestASessionClicked)="onRequestSessionButtonClicked()"
                >
                </connect-card>
              </div>

              @if (!fromClientPortal && costEstimateEnabled() && providerShareableProfile) {
                <cost-estimate-psl
                  [providerShareableProfile]="providerShareableProfile"
                  (requestASessionClicked)="onRequestSessionButtonClicked()"
                ></cost-estimate-psl>
              }

              <find-my-fit
                *ngIf="!fromClientPortal && directoryCompanionEnabled()"
                (findMyFit)="findMyFitClicked($event)"
                (moduleViewed)="onAiConnectModuleViewed()"
                (startButtonClicked)="onAiConnectStartButtonClicked($event)">
              </find-my-fit>

              <div *ngIf="fromClientPortal" class="book-session-card-container">
                @if (isClientPortalProviderLoading() || isCalendarLoading) {
                  <iris-card class="book-session-card" [elevation]="1">
                    <div>
                      <div class="skeleton-line skeleton-header"></div>
                      <div class="skeleton-line skeleton-text"></div>
                      <div class="skeleton-loader skeleton-button"></div>
                    </div>
                  </iris-card>
                } @else if ((showProviderCalendar$ | async) && providerSchedulingEnabled()) {
                  <iris-card
                    class="provider-calendar-card"
                    data-test="client-portal-calendar"
                    [elevation]="1"
                  >
                    <public-provider-calendar
                      [appointmentSlots]="appointmentSlots$ | async"
                      (appointmentSlotsProcessed)="onCalendarInit($event)"
                      (requestASessionClicked)="onBookSessionButtonClicked($event)"
                      [providerId]="providerShareableProfile?.id"
                      [providerPrimaryAddress]="providerPrimaryAddress"
                      [providerSessionTypesOffered]="providerShareableProfile?.session_types_offered"
                      [providerTimeZone]="providerShareableProfile?.time_zone"
                    >
                    </public-provider-calendar>
                  </iris-card>
                } @else if (providerSchedulingEnabled()) {
                  <iris-card class="book-session-card" [elevation]="1">
                    <div>
                      <h2>Book a session with {{ clientPortalProvider()?.displayFirstName }}!</h2>
                      <p>If {{ clientPortalProvider()?.displayFirstName }} is a good fit for you, you can book a session with them.</p>

                      <iris-button
                        (click)="onBookSessionButtonClicked()"
                        data-test="book-session-mobile"
                      >
                        <span>Book a session</span>
                      </iris-button>
                    </div>
                  </iris-card>
                } @else {
                  <iris-card class="book-session-card" [elevation]="1">
                    <div>
                      <h2>Message {{ clientPortalProvider()?.displayFirstName }} to book a session.</h2>
                      <p>{{ clientPortalProvider()?.displayFirstName }} prefers to find a session time with you directly.</p>
                      <a
                        [routerLink]="['/chat/rooms', clientPortalProvider()?.providerId]"
                        class="iris-button iris-button--primary"
                        data-test="book-session-message"
                      >
                        <span>Message</span>
                      </a>
                    </div>
                  </iris-card>
                }
              </div>

              @if (!isUserLocaleOutsideAmerica) {
                <support-phone-number-card></support-phone-number-card>
              }
            </div>

          </div>

          <div class="provider-details-wrapper">
            <provider-details
              [providerShareableProfile]="providerShareableProfile"
              [topSpecialties]="topSpecialties"
          [queryParamMap]="queryParamMap"
            ></provider-details>
          </div>
        </div>
      </div>
        @if (!fromClientPortal) {
          <internal-link-module
            *nativeAppHidden
            [stateAbbrev]="(currentStateAbbrev$ | async) ?? ''">
          </internal-link-module>
        }

        <!-- Footer is contained within main to have body + footer be scrollable together -->
        <footer *ngIf="!fromClientPortal">
          <public-footer *nativeAppHidden>
          </public-footer>
        </footer>
      </main>

      <div
        *ngIf="!fromClientPortal"
        class="mobile-bottom-drawer"
        [ngClass]="{ 'hidden': isCalendarScrolledIntoView }"
        data-test="mobile-bottom-drawer"
      >
        <ng-container *ngTemplateOutlet="(isScheduled) ? scheduledSessionTemplate : bookSessionTemplate">
        </ng-container>
        <ng-template #scheduledSessionTemplate>
          <div class="success-container">
            <iris-icon name="check_circle" class="success-icon"></iris-icon>
            <span class="success-text">Session scheduled!</span>
          </div>
        </ng-template>

        <ng-template #bookSessionTemplate>
          <div class="drawer-content">
            <div class="drawer-next-available">
              <span class="drawer-label">Next available:</span>
              <span class="drawer-date">{{ soonestAvailableDate$ | async | date:'MMMM d' }}</span>
            </div>

            <iris-button-container>
              <iris-button
                (click)="onMobileDrawerButtonClicked()"
                  class="request-session-button"
                  data-test="book-session-mobile"
              >
                Choose a time
              </iris-button>
            </iris-button-container>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #notFound>
  <div class="page-not-found-container">
    <page-not-found [redirectUrl]="therapyMatchFlowUrl"></page-not-found>
  </div>
</ng-template>

<ng-template #loading>
  <div class="full-page-loader loading-spinner"></div>
</ng-template>